export const environment = {
    production: false,
    apiBaseUrl: 'https://aajeevika-stage.lokos.in/api/lokos-aajeevika/v3/aajeevika/',
    baseUrl: 'https://aajeevika-stage.lokos.in/',
    adminLokosBaseUrl: 'https://admin.lokos.in/',
    keyCloackApiUrlV2: 'https://api.lokos.in/',
    lokosApiBaseUrl: 'https://stage-fdm.lokos.in/api/profiles/v3/lokos-profile/',
    apisUrl: 'https://apis.lokos.in/',
    reportApiBaseUrl: 'https://stageprod.lokos.in/api/reports/v3/reporting/aajeevika/',
    cadreApiBaseUrl: 'https://stage-cadmob.lokos.in/api/cadre-profile/v1/',
    cdnUrl: 'https://cdn.lokos.in/lokos-masterdata/',
    secretKey: 'eab74d04-bb8f-41bd-8a8c-5a3a90fc3c37',
    keycloak: {
        issuer: 'https://identity.lokos.in/',
        realm: 'lokos',
        clientId: 'web-console',
    },
    firebaseConfig: {
        apiKey: "AIzaSyDkRgoY5k2kgdqrGaHqvGDFqaFr18U-0o0",
        authDomain: "lokos-90709.firebaseapp.com",
        projectId: "lokos-90709",
        storageBucket: "lokos-90709.appspot.com",
        messagingSenderId: "690583887786",
        appId: "1:690583887786:web:804347aff68c3773d5d5d3",
        measurementId: "G-Z2R7KBJDYK"
    },
    ocpApimSubscriptionKey: '5598bad5185c48efb912531c1fd18dcd',
    ocpApimSubscriptionKeyProd: '7511f1a237fa45898f255dd4a52b2282',
    ocpApimSubscriptionKeyForBankDetail: 'b09d4f667e604ebba5b3de0da9ab896f',
    apiKey: 'nTX595Aufpz9WAo5utI5Uw6RkOk3iDSS0rLudOKWT7AzSeB0ng4X',
    KEYCLOCK: 'api/keycloak/v1/',
    fdmApiBaseUrl: 'https://stage-fdm.lokos.in/',
    enableEncryption: true
};

